window.header = function () {
    return {
		isOpenResponsive: false,
        sticky: false, // Indikátor, či má byť `sticky` class aktívny
        lastScrollTop: 0, // Posledná pozícia scrollovania
        threshold: 200, // Vzdialenosť scrollovania, kedy pridáme/odstránime `sticky` class

        init() {
            this.lastScrollTop = window.scrollY; // Nastav počiatočnú pozíciu scrollovania
            window.addEventListener('scroll', () => {
                this.handleScroll();
            });

			document.querySelectorAll('.nav-mobile a').forEach(link => {
                link.addEventListener('click', () => {
                    this.closeResponsiveMenu();
                });
            });
        },

        handleScroll() {
            let currentScrollTop = window.scrollY || document.documentElement.scrollTop;

            if (currentScrollTop > this.threshold) {
                // Scroll nadol a prešiel hranicu threshold
                this.sticky = true;
            }

            if (currentScrollTop < this.lastScrollTop && currentScrollTop <= this.threshold) {
                // Scroll hore a vrátil sa pod hranicu threshold
                this.sticky = false;
            }

            // Uloženie aktuálnej pozície scrollovania pre ďalšie porovnanie
            this.lastScrollTop = currentScrollTop;
        },

		closeResponsiveMenu() {
            this.isOpenResponsive = false;
        },
    };
};
